import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeBombService } from './time-bomb-service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [TimeBombService]
})
export class TimeBombModule {}
